import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ReportDownloadDialog } from "../Ui/Dialogs/ReportDownloadDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandUserReportViewReportPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandUserReportViewReportProperties = {
    [name in keyof EntityCommandUserReportViewReportPropertyValues]: Property<EntityCommandUserReportViewReportPropertyValues[name]>
};

export interface IEntityCommandUserReportViewReport extends IEntityCommand, EntityCommandUserReportViewReportProperties
{
}

export class EntityCommandUserReportViewReport extends EntityCommand implements IEntityCommandUserReportViewReport
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandUserReportViewReport";
    public static override className = "EntityCommandUserReportViewReport";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandUserReportViewReportPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "View Report",
                entityName: "UserReport",
                isDefault: true,
                key: "VIEW_REPORT",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandUserReportViewReportPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller)
                        return;

                    if (!caller.reportDownloadDialog)
                        caller.reportDownloadDialog = new ReportDownloadDialog();

                    return caller.reportDownloadDialog.openAsync(recordId);
                })
        );
    }

    // #endregion

    // #endregion
}

